import { render, staticRenderFns } from "./ModalVideoPlayer.vue?vue&type=template&id=38751019&scoped=true&"
import script from "./ModalVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./ModalVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVideoPlayer.vue?vue&type=style&index=0&id=38751019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38751019",
  null
  
)

export default component.exports